<template>
  <!-- <v-container> -->
  <v-app>
    <v-main>
      <div class="text-center">
        <!-- <span class="headline">ทำแบบทดสอบ</span> -->
        <!-- <v-card class="mx-auto card-error" max-width="344" v-if="cantStartState">
        <v-card-text>
          <div>ไม่สามารถทำข้อสอบได้</div>
          <p>เนื่องจาก</p>
          <div class="text--primary">
            {{message}}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn text color="teal accent-4" @click="reveal = true">
            Learn More
          </v-btn>
        </v-card-actions>

        <v-expand-transition>
          <v-card
            v-if="reveal"
            class="transition-fast-in-fast-out v-card--reveal"
            style="height: 100%"
          >
            <v-card-text class="pb-0">
              <p class="display-1 text--primary">Origin</p>
              <p>
                late 16th century (as a noun denoting a place where alms were
                distributed): from medieval Latin eleemosynarius, from late
                Latin eleemosyna ‘alms’, from Greek eleēmosunē ‘compassion’
              </p>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-btn text color="teal accent-4" @click="reveal = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-expand-transition>
      </v-card> -->
        <v-row class="pa-12 ma-0 align-start" v-if="cantStartState">
          <v-col cols="12" sm="12" md="8" lg="6">
            <h2 class="text-center mb-4 red--text">ไม่สามารถเปิดข้อสอบได้</h2>
            <div>
              <div>เนื่องจาก: {{ message }}</div>

              <div class="text-center my-4">
                <v-btn color="error" @click="closeWebView" width="220" depressed
                  >กลับสู่คอร์สเรียน</v-btn
                >
              </div>
            </div>
          </v-col>
        </v-row>
        <img class="indicator" src="@/assets/activity_indicator.gif" v-else />
        <!-- <v-dialog v-model="cantStartState" max-width="450">
        <v-card>
          <v-card-title class="headline">ไม่สามารถเปิดข้อสอบได้</v-card-title>

          <v-card-text>{{message}}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" text @click="closeWebView">กลับไปยังคอร์สเรียน</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
        <!-- <p class="body-2">คำอธิบาย</p> -->
      </div>
    </v-main>
  </v-app>
  <!-- <v-row class="py-8">
      <v-col class="text-center">
        <v-btn dark color="primary" to="exam" large>
          <v-icon left>fal fa-book</v-icon>
          <span>ทำแบบทดสอบ</span>
        </v-btn>
      </v-col>
    </v-row> -->
  <!-- </v-container> -->
</template>

<script>
var CryptoJS = require("crypto-js");
import examStatusCode from "../statuscode/exam";
export default {
  data: () => ({
    token: null,
    examId: null,
    lectureId: null,
    courseId: null,
    numStamp: null,
    cantStartState: false,
  }),
  async mounted() {
    let secret = "kJYSb2aTHqa3JBGV";
    let encryptTicket = this.$route.query.ticket;

    // if (encryptTicket) {
    let decode_query_uri = decodeURIComponent(encryptTicket);
    let decrypted = CryptoJS.AES.decrypt(decode_query_uri, secret);
    let ticketDetail = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

    let { token, idexam, idlecture, idcourse, numStamp } = ticketDetail;
    this.token = token;
    this.examId = idexam;
    this.lectureId = idlecture;
    this.courseId = idcourse;
    this.numStamp = numStamp;

    // } else {
    //   this.token = this.$route.query.token;
    //   this.examId = this.$route.query.idexam;
    //   this.lectureId = this.$route.query.idlecture;
    //   this.courseId = this.$route.query.idcourse;
    // }

    if (
      this.token &&
      this.examId &&
      this.lectureId &&
      this.courseId &&
      this.numStamp
    ) {
      this.$store.commit("setToken", this.token);
      const customTheme = this.$route.query.color;
      if (customTheme) {
        this.$vuetify.theme.themes.light.primary = "#" + customTheme;
      }
      await this.startState();
    } else {
      this.$router.replace({
        name: "error",
        params: {
          code: "0x002",
        },
      });
    }
  },
  methods: {
    startState() {
      let service = `${this.$store.state.api}/startState?idexam=${this.examId}&idcourse=${this.courseId}&idlecture=${this.lectureId}&numStamp=${this.numStamp}`;

      const config = {
        headers: {
          "x-session-token": this.$store.state.token,
          "server-name": this.$store.state.serverName,
        },
      };

      this.$http
        .get(service, config)
        .then((resp) => {
          // console.log(resp);

          if (resp.status == 200 && resp.data.status == true) {
            let ticketDetail = {
              ticket: resp.data.result.ticket,
              token: this.token,
            };
            this.$store.commit("setTicket", ticketDetail);

            // let ticket = resp.data.result.ticket;
            this.confirmTakeExam(resp.data.result.ticket)
            this.$router.replace({
              name: "examNoParam",
            });
          } else {
            // summary err
            alert(resp.data.message);
          }
        })
        .catch((err) => {
          // summary err
          this.cantStartState = true;
          this.message = "เกิดข้อผิดพลาด";
          let statusCode = err.response.data.statusCode;

          if (statusCode == examStatusCode.HAS_BEEN_USED) {
            this.message = "ตั๋วถูกใช้งานไปแล้ว";
          } else if (statusCode == examStatusCode.LIMIT_EXCEED) {
            this.message = "จำนวนครั้งในการสอบครบแล้ว";
          } else if (statusCode == examStatusCode.UNPUBLISHED) {
            this.message = "ข้อสอบนี้ยังไม่เปิดใช้งาน";
          } else if (statusCode == examStatusCode.TOO_EARLY) {
            this.message = "ยังไม่ถึงเวลาในการสอบ";
          } else if (statusCode == examStatusCode.OVERDUE) {
            this.message = "หมดเวลาในการสอบ";
          }
        });
      // .finally(() => {
      //   this.doProcess = false;
      // });
    },
    closeWebView() {
      if (typeof closeExam !== "undefined") {
        closeExam.postMessage("true");
      } else {
        console.debug("not running inside a Flutter webview");
        window.opener.postMessage("close", "*");
        window.close();
      }
    },
    confirmTakeExam(ticketId) {
      const config = {
        headers: {
          "x-session-token": this.$store.state.token,
          "server-name": this.$store.state.serverName,
        },
      };
      const payload = {
        ticketId: ticketId
      };
      this.$http
        .post(
          `${this.$store.state.api}/confirmTakeExam`,
          payload,
          config
        )
        .then((resp) => {
        })
        .catch((err) => {
          // service error
        })
    },
  },
};
</script>
<style lang="scss" scoped>
.indicator {
  width: 50px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card-error {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.box-score {
  padding: 24px;
  width: 400px;
  max-width: 100%;
  margin: 32px auto;
  background: #f5f5f5;
  border-radius: 8px;
}

.row {
  height: 100%;
  background: #f5f5f5;
}

.col-12 {
  margin: 0 auto;
  padding: 32px;
  position: relative;
  background: #ffffff;
  border-radius: 8px;
}
.v-btn--icon {
  position: absolute;
  top: 16px;
  right: 16px;
}
</style>
